<template>
    <div class="py-12 bg-gray-700 transition duration-150 ease-in-out z-10 absolute top-0 right-0 bottom-0 left-0" id="modal">
        <div role="alert" class="container mx-auto w-11/12 md:w-2/3 max-w-lg">
            <div class="py-8 px-5 bg-white shadow-md rounded border border-gray-400">
                <div class="w-full flex justify-center text-gray-600 mb-4">
                    <svg aria-hidden="true" role="img" class="iconify iconify--iconoir" width="56" height="56" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                        <g stroke-width="1.5" fill="none">
                            <path d="M10 9H6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M15.5 11a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M6 6h3" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M18 18l-4.5-3l-2.5 2l-5-4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M3 20.4V3.6a.6.6 0 0 1 .6-.6h16.8a.6.6 0 0 1 .6.6v16.8a.6.6 0 0 1-.6.6H3.6a.6.6 0 0 1-.6-.6z" stroke="currentColor"></path>
                        </g>
                    </svg>
                </div>
                <div class="flex flex-col w-full items-start justify-center space-y-[10px] px-[20px]">
                    <div class="flex flex-col w-full">
                        <h1 class="text-gray-800 text-sm font-bold tracking-normal leading-tight mb-[2px]">Report Name</h1>
                        <input required type="text" v-model="form.name" id="name"
                               class="mb-5 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                               placeholder=""/>
                    </div>
                    <div class="flex flex-col w-full">
                        <h1 class="text-gray-800 text-sm font-bold tracking-normal leading-tight mb-[2px]">Report Description</h1>
                        <textarea required v-model="form.description" id="description"
                                  class="mb-5 h-[100px] text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                                  placeholder=""></textarea>
                    </div>
                </div>
                <div class="flex items-center justify-center w-full">
                    <button @click="submit" class="focus:outline-none transition duration-150 ease-in-out hover:bg-indigo-600 bg-indigo-700 rounded text-white px-8 py-2 text-sm">Create</button>
                    <button class="focus:outline-none ml-3 bg-gray-100 transition duration-150 text-gray-600 ease-in-out hover:border-gray-400 hover:bg-gray-300 border rounded px-8 py-2 text-sm" @click="show = !show">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import {useForm} from "@inertiajs/inertia-vue3";
import {ref, watch} from "vue";

const form = useForm({
    name: 'Custom report name',
    description: 'Custom report description',
})

const emit = defineEmits(['close'])

const show = ref(true)

watch(show, (next, prev) => {
    if (next !== prev) {
        modalHandler(next)
    }
})

const submit = async () => {
    await form.post('/reports/custom/create', {replace: true})
}

const modalHandler = (val) => {
    let modal = document.getElementById("modal");
    if (val) {
        fadeIn(modal);
    } else {
        fadeOut(modal);
    }
}
const fadeOut = (el) => {
    el.style.opacity = 1;
    (function fade() {
        if ((el.style.opacity -= 0.1) < 0) {
            el.style.display = "none";
        } else {
            requestAnimationFrame(fade);
        }

        emit('close')
    })();
}
const fadeIn = (el, display) => {
    el.style.opacity = 0;
    el.style.display = display || "flex";
    (function fade() {
        let val = parseFloat(el.style.opacity);
        if (!((val += 0.2) > 1)) {
            el.style.opacity = val;
            requestAnimationFrame(fade);
        }
    })();
}
</script>
